import { Source } from 'apiConnector/quote-loading';
import { connect } from 'react-redux';
import type { ThunkDispatch } from 'state/state.common';
import { workspaceQuoteLoaded } from 'state/workspaces/workspace.actions';

export interface LoadQuoteRouteProps {
  onQuoteLoaded(externalId: string, source?: Source): void;
}

const mapDispatchToProps = (dispatch: ThunkDispatch): LoadQuoteRouteProps => {
  return {
    onQuoteLoaded(externalId, source) {
      dispatch(workspaceQuoteLoaded(externalId, undefined, undefined, source));
    },
  };
};

export const connectLoadQuoteRoute = connect(undefined, mapDispatchToProps);
